import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddCommunityPopup from "./AddCommunityPopup";

interface CommunityEmptyPageProps {
  onCommunityCreated?: (newCommunity: any) => void;
}

export default function CommunityEmptyPage({ onCommunityCreated }: CommunityEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Communities"
      colorKey="community"
      AddPopupComponent={AddCommunityPopup}
      onEntityCreated={onCommunityCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Community",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Community",
          openPopup: true,
        },
        {
          id: "details",
          type: "text",
          text: "View Details of a Community",
          direction: "down",
        },
      ]}
    />
  );
}
